
import React, { useState } from 'react';






import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import {
    Row,
  } from "reactstrap";






const TrainingScoreHelpModal = (props) => {
  const {
    buttonLabel,
    className
  } = props;

  
  const [modal, setModal] = useState(false);
  

  const toggle = () => setModal(!modal);

  
  return (
    <div>
      <i onClick={toggle} className="now-ui-icons media-2_sound-wave" style={{color:'rgb(255,200,100)',cursor:'pointer'}}/> <span className={props.colorForm}>--</span>
      <Modal isOpen={modal} toggle={toggle} className={className} style={{backgroundColor:'rgb(40,40,40)'}}>
        <ModalHeader toggle={toggle} style={{backgroundColor:'rgb(40,40,40)',color:'rgb(48, 189, 255)'}}>Training Score</ModalHeader>
        <ModalBody style={{backgroundColor:'rgb(40,40,40)',color:'rgb(48, 189, 255)'}}>
          <div class="form-group">
            <Row style={{padding:'10px'}}>     
                <h3 className='text-warning'>Help</h3>      
                <p className='text-white'>Training score is calculated using mainly the deviation of the program ( lower deviation - higher score ) and the deviation of your average Perceived stress from the target value.</p>
            </Row>
          </div>
        </ModalBody>
        <ModalFooter style={{backgroundColor:'rgb(40,40,40)',color:'rgb(48, 189, 255)'}}>
          <Button color="danger" onClick={toggle}>Close</Button>
        </ModalFooter>
      </Modal>
    </div>
  );
}

export default TrainingScoreHelpModal;